import { Fragment } from 'react';
import { classNames } from '../../Services/helpers';
import Markdown from '../Formatting/Markdown';
import Preview from '../Gallery/Preview';
import Icon from '../Icons/Icon';

const Entries = ({entries, submitMessage, files}) => {
    // Hide the 'Sid joined' if it's the first message
    return entries.filter((e, i) => i !== 0 || e.type !== 'assistantActivated').map((message, index) => {
        if (message.type === 'assistantActivated' || message.type === 'assistantDeactivated') {
            return <SystemMessage key={index}
                message={
                    message.type === 'assistantActivated' ?
                        'Sid has joined the conversation' :
                        'Sid has left the conversation'
                    }
            />
        }

        if (message.type === 'humanAttentionRequested' || message.type === 'humanAttentionRemoved') {
            return <SystemMessage key={index}
                message={
                    message.type === 'humanAttentionRequested' ?
                        'The conversation has been flagged for human attention' :
                        null
                    }
            />
        }

        if (!message.message) {
            return null;
        }
        if (message.role === 'System' || message.message.startsWith('#INTERNAL')) {
            return null;
        }
        if (message.sending) {
            return <p key={index} className={classNames(
                'max-w-[90%] p-2 rounded-lg',
                'border border-dashed border-blue-100 dark:border-blue-800',
                'self-end bg-slate-100/80 dark:bg-slate-700/80 text-muted italic prose-gray',
            )}>
                {message.message}
            </p>
        }

        return <Fragment key={index}>
            <div className={classNames(
                    'max-w-[90%] p-2 rounded-lg text-balance',
                    message.role === 'User' ? 'self-end text-right italic prose-gray' : 'self-start left-left',
                    message.role === 'User' ? 'bg-sky-100 dark:bg-sky-700 dark:text-slate-200 rounded-br-none' : 'bg-slate-100 dark:bg-slate-700 dark:text-slate-200 rounded-bl-none',
                    message.role === 'Admin' && 'border-l border-brand',
                )}>
                <Markdown markdown={message.message}
                    className="[&>:first-child]:mt-0 [&>:last-child]:mb-0"
                    btnCallback={submitMessage}
                    files={files}
                />
                {message.role === 'Admin' && <p className="mt-2 mb-0 flex items-center text-brand text-xs">
                    <Icon icon="User" theme="solid" size="0.5x" className="fill-brand mr-2" />
                    Malcolm
                </p>}
            </div>
            {message.assetIds && <Preview assetIds={message.assetIds} align={message.role === 'User' ? 'right' : 'left'} />}
        </Fragment>
    })
}

const SystemMessage = ({message}) => {
    if (!message) {
        return null;
    }

    return <p className={classNames(
        'my-0 max-w-[80%] p-2 rounded-lg',
        // 'border border-dashed border-blue-100',
        'self-center bg-slate-50 dark:bg-slate-800 text-muted italic prose-gray text-center text-balance',
    )}>
        {message}
    </p>
}

export default Entries;
